export default __webpack_public_path__ + "static/media/search.2550c90b.png";